var version = "10.22.0";

export { version as v };
//# sourceMappingURL=package-2ae26d74.js.map
